import { IAddVariable } from "./types";

export const firstName: IAddVariable = {
  id: "firstName",
  label: "First Name",
  placeholder: "{{first name}}",
};
